import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconDirective, IconSetService } from '@coreui/icons-angular';

import {
  cibTwitter,
  cibYoutube,
  cibFacebook,
  cibLinkedin,
  cibInstagram,
} from '@coreui/icons';

@Component({
  selector: 'app-static-footer',
  standalone: true,
  imports: [RouterModule, IconDirective],
  templateUrl: './static-footer.component.html',
  styleUrls: ['./static-footer.component.scss'],
})
export class StaticFooterComponent {
  constructor(private iconSet: IconSetService) {
    this.iconSet.icons = {
      cibInstagram,
      cibYoutube,
      cibFacebook,
      cibLinkedin,
      cibTwitter
    };
  }

  // Expose icons to template
  cibTwitter = cibTwitter;
  cibYoutube = cibYoutube;
  cibFacebook = cibFacebook;
  cibLinkedin = cibLinkedin;
  cibInstagram = cibInstagram;
}
